import classNames from "classnames";
import React from "react";
import { ContentWrapper } from "../../layout/ContentWrapper/ContentWrapper";
import { PageDrawer } from "../PageDrawer";
import { PageHeader } from "../PageHeader";
import { PageStickyProvider } from "../PageStickyProvider";
import styles from "./styles.scss";

export const Page = ({ children }) => {
    let mainBox = [];
    let pageHeader = null;
    let pageDrawer = null;

    React.Children.map(children, (child) => {
        if (child) {
            if (React.isValidElement(child) && child.type === PageHeader) {
                pageHeader = child;
            } else if (React.isValidElement(child) && child.type === PageDrawer) {
                pageDrawer = child;
            } else {
                mainBox.push(child);
            }
        }
    });

    return (
        <PageStickyProvider
            hasHeader={!!pageHeader}
            render={({ topSentinelRef, headerBlockRef, contentSentinelRef, pinnedHeader }) => (
                <div className={styles.base}>
                    {pageDrawer && <div className={styles.drawerPane}>{pageDrawer}</div>}
                    <div className={styles.mainPane}>
                        <div ref={topSentinelRef} />
                        {pageHeader && (
                            <div
                                ref={headerBlockRef}
                                className={classNames(styles.headerBlock, { [styles.pinned]: pinnedHeader })}
                            >
                                {React.cloneElement(pageHeader, { pinned: pinnedHeader })}
                            </div>
                        )}
                        {mainBox.length > 0 ? (
                            <div className={styles.contentBlock}>
                                <div ref={contentSentinelRef} />
                                <ContentWrapper>{mainBox}</ContentWrapper>
                            </div>
                        ) : null}
                    </div>
                </div>
            )}
        />
    );
};
